import { useState } from 'react'
import { signIn } from 'next-auth/react'
import GithubIcon from '@/assets/svg/github.svg'

import Button from '@/components/ui/Button'

import { t } from '@/lib/i18n'
import Spinner from './Spinner'
import Image from 'next/image'

export interface SignUpFormdData {
  email: string
  code: string
}

export default function SigninForm() {
  const [loading, setLoading] = useState(false)

  return (
    <div className='border border-gray-200 rounded-lg p-4 shadow-sm sm:p-6 mb-6 flex flex-col justify-center items-center'>
      <h3 className='text-xl font-medium text-gray-900 mb-5'>
        {t('Sign in with GitHub to join the waitlist:')}
      </h3>
      <Button
        primary
        onClick={() => {
          setLoading(true)
          signIn('github')
          setLoading(false)
        }}
      >
        {loading ? <Spinner className='h-6 w-6' /> : 'Sign in with GitHub'}
        <Image src={GithubIcon} alt='github-icon' />
      </Button>
    </div>
  )
}
